import { BarController, BarElement, CategoryScale, Chart, LinearScale, Tooltip } from 'chart.js'
import { ChartTitle } from 'components/atoms/ChartTitle'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { colors } from 'theme'
import { chartOptions } from 'utils/chartOptions'

const data = {
  type: 'bar',
  data: {
    labels: [],
    datasets: [
      {
        label: 'Nb de quiz fait*',
        backgroundColor: colors.blueChart,
        data: [],
      },
      {
        label: 'Nb de quiz validés',
        backgroundColor: colors.lightGreen,
        data: [],
      },
      {
        label: 'Nb de quiz refaits',
        backgroundColor: colors.deepGold,
        data: [],
      },
    ],
  },
}

const AverageScore = ({ selectedMember, scores, formatedMonthYears }) => {
  const canvas = useRef(null)
  useEffect(() => {
    Chart.register(CategoryScale, LinearScale, BarController, BarElement, Tooltip)

    const chart = new Chart(canvas.current.getContext('2d'), {
      ...data,
      data: {
        ...data.data,
        labels: formatedMonthYears,
        datasets: [{
          ...data.data.datasets[0],
          data: scores?.map(score => score.averageQuizDone),
          barThickness: canvas.current.offsetWidth > 768 ? 40 : 15,
        },
        {
          ...data.data.datasets[1],
          data: scores?.map(score => score.averageQuizValidated),
          barThickness: canvas.current.offsetWidth > 768 ? 40 : 15,
        },
        {
          ...data.data.datasets[2],
          data: scores?.map(score => score.averageQuizRedone),
          barThickness: canvas.current.offsetWidth > 768 ? 40 : 15,
        }],
      },
      options: chartOptions,
    })

    return () => chart.destroy()
  }, [scores, formatedMonthYears])

  const memberName = selectedMember === 'team'
    ? "l'équipe"
    : `${selectedMember?.firstname} ${selectedMember?.lastname}`

  return (
    <Wrapper>
      <ChartTitle title={`Moyennes mensuelles de ${memberName}`}>
        <LegendWrapper>
          <Legend>
            <Square $color={ colors.blueChart } />
            <LegendName>
              Nb de quiz faits*
            </LegendName>
          </Legend>
          <Legend>
            <Square $color={ colors.lightGreen } />
            <LegendName>
              Nb de quiz validés
            </LegendName>
          </Legend>
          <Legend>
            <Square $color={ colors.deepGold } />
            <LegendName>
              Nb de quiz refaits
            </LegendName>
          </Legend>
        </LegendWrapper>
      </ChartTitle>
      <ChartContainer>
        <canvas id="averageScore"
          ref={ canvas }
        >
        </canvas>
      </ChartContainer>
      <Info>
        <InfoBold>* Quiz fait</InfoBold>
        {'* Quiz terminé, validé ou non. Un Quiz est validé pour un score >= à 70/100 points.'}
      </Info>
    </Wrapper>
  )
}

AverageScore.propTypes = {
  selectedMember: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      firstname: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  formatedMonthYears: PropTypes.arrayOf(PropTypes.string).isRequired,
  scores: PropTypes.arrayOf(PropTypes.shape({
    averageQuizDone: PropTypes.number.isRequired,
    averageQuizValidated: PropTypes.number.isRequired,
    averageQuizRedone: PropTypes.number.isRequired,
  })).isRequired,
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ChartContainer = styled.div`
  position: relative;
  height: 400px;
`

const LegendWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
`

const Legend = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Square = styled.span`
  display: flex;
  min-width: 0.875rem;
  min-height: 0.875rem;
  background-color: ${({ $color }) => $color};
`

const LegendName = styled.span`
  margin-right: 1.875rem;
  margin-left: 0.5rem;
  font-family: 'brother-1816';
  font-size: 0.875rem;
  color: ${colors.deepBlue};
  opacity: 0.5;
`

const Info = styled.span`
  font-family: 'brother-1816';
  font-size: 0.875rem;
  color: ${colors.darkGray};
`

const InfoBold = styled.span`
  font-weight: 600;
`

export default AverageScore
